const mugologyColourCycleTimers = new WeakMap();

function stopMugologyColourCycle(card) {
  const timer = mugologyColourCycleTimers.get(card);
  if (timer) window.clearInterval(timer);
  mugologyColourCycleTimers.delete(card);

  const images = card.querySelectorAll('.mugology-product__colour-image');
  images.forEach((image, index) => image.classList.toggle('is-active', index === 0));
}

function startMugologyColourCycle(event) {
  if (event.pointerType !== 'mouse') return;

  const card = event.currentTarget;
  const images = [...card.querySelectorAll('.mugology-product__colour-image')];
  if (images.length < 2) return;

  stopMugologyColourCycle(card);
  let current = 0;
  const timer = window.setInterval(() => {
    images[current].classList.remove('is-active');
    current = (current + 1) % images.length;
    images[current].classList.add('is-active');
  }, 1400);

  mugologyColourCycleTimers.set(card, timer);
}

function initialiseMugologyColourCycles(root = document) {
  root.querySelectorAll('[data-mugology-colour-cycle]').forEach((card) => {
    if (card.dataset.mugologyCycleReady === 'true') return;
    card.dataset.mugologyCycleReady = 'true';
    card.addEventListener('pointerenter', startMugologyColourCycle);
    card.addEventListener('pointerleave', (event) => { if (event.pointerType === 'mouse') stopMugologyColourCycle(card); });
  });

  root.querySelectorAll('[data-mugology-colour-dots]').forEach((dots) => {
    if (dots.dataset.mugologyDotsReady === 'true') return;
    dots.dataset.mugologyDotsReady = 'true';

    dots.querySelectorAll('[data-mugology-colour-index]').forEach((dot) => {
      const showColour = () => {
        const index = Number(dot.dataset.mugologyColourIndex);
        const customCard = dot.closest('.mugology-product');
        const nativeCard = dot.closest('product-card');

        dots.querySelectorAll('.mugology-colour-dot').forEach((item) => item.classList.toggle('is-active', item === dot));

        if (customCard) {
          const media = customCard.querySelector('[data-mugology-colour-cycle]');
          if (!media) return;
          stopMugologyColourCycle(media);
          media.querySelectorAll('.mugology-product__colour-image').forEach((image, imageIndex) => {
            image.classList.toggle('is-active', imageIndex === index);
          });
        } else if (nativeCard?.showMugologyColour) nativeCard.showMugologyColour(index);
      };

      dot.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') showColour();
      });

      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        showColour();
      });
    });

    dots.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      dots.querySelectorAll('.mugology-colour-dot').forEach((item) => item.classList.remove('is-active'));
      const customCard = dots.closest('.mugology-product');
      const nativeCard = dots.closest('product-card');
      if (customCard) {
        const media = customCard.querySelector('[data-mugology-colour-cycle]');
        if (media) startMugologyColourCycle({ pointerType: 'mouse', currentTarget: media });
      } else if (nativeCard?.resumeMugologyColourCycle) nativeCard.resumeMugologyColourCycle();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initialiseMugologyColourCycles();
    document.querySelectorAll('a').forEach((link) => {
      if (link.textContent.trim().toLowerCase() === 'catalog') link.href = '/collections';
    });
  });
} else {
  initialiseMugologyColourCycles();
}

document.addEventListener('shopify:section:load', (event) => initialiseMugologyColourCycles(event.target));
